const amplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_QwBTyQHJj',
            userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID || '2njtvln5ureosm5u92i259kp9k',
            identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || 'us-east-1:8fc7cade-4dc4-4121-bf41-ef2129750ffa',
            signUpVerificationMethod: 'code' as const,
        },
    },
};

export default amplifyConfig;
